/**
 * 云空间上传文件进度列表组件
 */
import React, { useCallback, useRef } from "react";
import GroupUploadBox from "./baseComponents";
import { groupJoyspaceKey } from "@/components/Joyspace/components/GroupUploadPanel/UploadController";

import context, { useTranslation } from "../../context";
import { analysisLog } from "@/utils/logAnalytics";
import { debounce } from "lodash";
import events from "../../context/events";

interface IProps {
  gid: string;
}
function GroupJoySpaceUploadBox(props: IProps) {
  const { gid } = props;
  const ref = useRef<HTMLDivElement | null>(null);
  const lang = useTranslation();
  //   const { currentRouterInfo } = useContext(context);
  const uploadSuccessCallBackFunc = (data: any) => {
    let doUpload = debounce((folderId) => {
      events.emit("list.reload", { folderId });
    }, 1000);
    doAnalysisLog({
      status: "成功",
      name: data?.file?.name,
      type: data?.file?.type,
      folderId: data?.file?.folderId
    });

    doUpload(data?.file?.folderId);
  };
  const uploadFailCallBackFunc = (data: any) => {
    doAnalysisLog({
      status: "失败",
      name: data?.file?.name,
      type: data?.file?.type,
      folderId: data?.file?.folderId
    });
  };
  const doAnalysisLog = useCallback(
    (data: { status: string; name: string; type: string; folderId: string }) => {
      const { status, name, type, folderId } = data;
      analysisLog("xtbg_jzb_joyspace_home_1676548210761", "38", "", status, name, folderId, type);
    },
    []
  );

  return (
    <GroupUploadBox
      ref={ref}
      uploadControlName={groupJoyspaceKey}
      toJoysSapce={true}
      headerTitle=""
      // retryLimitCallBackFunc={retryLimitCallBackFunc}
      uploadSuccessCallBackFunc={uploadSuccessCallBackFunc}
      uploadFailCallBackFunc={uploadFailCallBackFunc}
      gid={gid}
      className="joyspace-upload"
    />
  );
}

export default GroupJoySpaceUploadBox;
